'use strict';
import * as _ from 'lodash';

export class CannedNotesModel {
  constructor({
    noteItems,
    comment,
  })
   {
    this.comment = comment;
    this.initComment = comment;
    this.noteItems = noteItems;
  }

  canCancel() {
    return this.initComment === this.comment;
  }

  clearBox(){
    this.comment = '';
  }
}



// WEBPACK FOOTER //
// ./src/scripts/models/cannedNotesModel.js